import { useState, useEffect, useRef, useCallback } from 'react'

/**
 * Hook that provides a ticker for real-time updates.
 * Returns a tick value that increments every interval.
 */
export function useTicker(intervalMs = 250): { tick: number; start: () => void; stop: () => void } {
  const [tick, setTick] = useState(0)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const start = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }

    intervalRef.current = setInterval(() => {
      setTick(prev => prev + 1)
    }, intervalMs)
  }, [intervalMs])

  const stop = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }, [])

  // Start ticker on mount
  useEffect(() => {
    start()
    return () => stop()
  }, [start, stop])

  return { tick, start, stop }
}
